import React, { useState, useEffect, useRef } from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

// Desktop + Mobile hero images — imported separately
import HeroBgImg       from "../../asset/images/products/vedika-7khz/hero-bg.webp";
import HeroBgImgMobile from "../../asset/images/products/vedika-7khz/hero-bg-mobile.webp";

import SlideImg1 from "../../asset/images/products/vedika-7khz/slide-1.webp";
import SlideImg2 from "../../asset/images/products/vedika-7khz/slide-2.webp";
import SlideImg3 from "../../asset/images/products/vedika-7khz/slide-3.webp";

import DatasheetTabIcon   from "../../asset/images/products/vedika-7khz/datasheet-icon.svg";
import InstructionTabIcon from "../../asset/images/products/vedika-7khz/instruction-icon.svg";
import WhitepaperTabIcon  from "../../asset/images/products/vedika-7khz/whitepaper-icon.svg";
import PdfSvgIcon         from "../../asset/images/products/1-phase/pdf-icon.svg";
import DatasheetPdf from "../../asset/images/products/vedika-7khz/Datasheet.pdf"; 
import InstructionManual from "../../asset/images/products/vedika-7khz/Instruction-Manual.pdf"; 
import CleanAirWhitePaper from "../../asset/images/products/vedika-7khz/CleanAirWhitePaper.pdf";


const SLIDES = [SlideImg1, SlideImg2, SlideImg3];
const AUTOPLAY_SPEED = 30000;

const BULLETS = [
  "Ador has a robust solution which is not a project and doesn't need any mechanical or process shut down for enhancing performance of ESP.",
  "Ador has a technical tie up with Redkoh industries USA and we have a patent panel suitable for your existing TR and ESP to enhance performance of ESP.",
  "We have recently developed a high frequency panel which is suitable for existing Single phase transformer.",
  "By replacing this panel from conventional SCR based panels with same TR we have seen some good results at various sites.",
  "The emission level can be lowered to approximately 30% to 50% from the existing level depending upon mechanical and site condition by better and enhanced way of treatment of dust with use of high frequency ESP control panels, keeping the rectifier TR and ESP mechanical same as existing",
];

const TABS = [
  {
    key: "datasheet",
    label: "Datasheet",
    downloads: [{ label: "Datasheet | 259KB", href: DatasheetPdf }],
  },
  {
    key: "instruction",
    label: "Instruction Manual",
    downloads: [{ label: "Instruction Manual | 259KB", href: InstructionManual }],
  },
  {
    key: "whitepaper",
    label: "White Paper",
    downloads: [{ label: "White Paper | 259KB", href: CleanAirWhitePaper }],
  },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .vdk-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .vdk-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .vdk-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .vdk-hero-bg-mobile {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: none;
  }
  .vdk-hero-overlay {
    position: absolute;
    inset: 0;
  }
  .vdk-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .vdk-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 700;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .vdk-hero-divider {
    width: 320px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 18px;
  }
  .vdk-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 150%;
    max-width: 400px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .vdk-breadcrumb {
    padding: 40px 0 0 0;
  }
  .vdk-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .vdk-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .vdk-bc-item:hover { color: #EB2019; }
  .vdk-bc-item.vdk-active { color: #202020; }
  .vdk-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .vdk-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CONTENT — left text + right slider
  ══════════════════════════════════════════ */
  .vdk-section-content {
    padding: 80px 0 120px 0;
  }
  .vdk-content-grid {
    display: flex;
    gap: 90px;
    align-items: center;
  }
  .vdk-content-left {
    flex: 0 0 594px;
  }
  .vdk-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #EB2019;
    margin-bottom: 14px;
    line-height: 140%;
  }
  .vdk-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #202020;
    margin-bottom: 20px;
  }

  /* Bullet list */
  .vdk-bullet-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .vdk-bullet-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 155%;
    padding: 4px 0 4px 18px;
    position: relative;
  }
  .vdk-bullet-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* Slider */
  .vdk-slider {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .vdk-slider-img-wrap {
    width: 100%;
    height: 500px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    cursor: grab;
    user-select: none;
  }
  .vdk-slider-img-wrap:active { cursor: grabbing; }
  .vdk-slider-track {
    display: flex;
    height: 100%;
    transition: transform 0.6s ease;
  }
  .vdk-slider-track .vdk-slider-img {
    min-width: 100%;
    flex-shrink: 0;
  }
  .vdk-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .vdk-slider-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .vdk-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #B8B7B7;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s;
  }
  .vdk-dot.vdk-dot-active { background: #EB2019; }

  /* ══════════════════════════════════════════
     4. TABS SECTION — Datasheet / Instruction / Whitepaper
  ══════════════════════════════════════════ */
  .vdk-tabs-section {
    padding: 0 0 120px 0;
  }
  .vdk-tabs-bar {
    display: flex;
    margin-bottom: 42px;
    overflow: visible;
  }

  /* Active tab */
  .vdk-tab-active {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    background: #B91E1A;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
    white-space: nowrap;
  }
  .vdk-tab-active::after {
    content: '';
    position: absolute;
    bottom: -13px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 13px solid #B91E1A;
    z-index: 2;
  }

  /* Inactive tab */
  .vdk-tab-inactive {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    background: #F1F1F1;
    color: #202020;
    border: none;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;
  }
  .vdk-tab-inactive:hover { background: #e4e4e4; }

  .vdk-tab-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
  .vdk-tab-active .vdk-tab-icon   { filter: brightness(0) invert(1); }
  .vdk-tab-inactive .vdk-tab-icon { filter: brightness(0); }

  /* ── Download row ── */
  .vdk-download-list {
    display: flex;
    flex-direction: column;
    border: 1px solid #B8B8B8;
    overflow: hidden;
    width:698px;
  }
  .vdk-download-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-bottom: 1px solid #B8B8B8;
    text-decoration: none;
    transition: background 0.2s;
    
  }
  .vdk-download-row:last-child { border-bottom: none; }
  .vdk-download-row:hover { background: #F6F6F6; }
  .vdk-download-label {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #202020;
    padding: 0 24px;
    flex: 1;
  }
  .vdk-download-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 60px;
    border-left: 1px solid #B8B8B8;
  }
  .vdk-pdf-icon {
    width: 44px;
    height: 44px;
    display: block;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .vdk-hero              { height: 300px; }
    .vdk-hero-bg           { display: block; }
    .vdk-hero-bg-mobile    { display: none; }
    .vdk-hero-content      { padding: 0 32px; }
    .vdk-hero-title        { font-size: 30px; }
    .vdk-hero-divider      { width: 260px; }
    .vdk-hero-desc         { font-size: 14px; }

    .vdk-breadcrumb        { padding: 28px 0 0 0; }
    .vdk-breadcrumb-inner  { padding: 0 32px; }
    .vdk-inner             { padding: 0 32px; }

    .vdk-section-content   { padding: 40px 0 0px 0; }
    .vdk-content-grid      { flex-direction: column-reverse; gap: 24px; }
    .vdk-content-left      { flex: none; width: 100%; }
    .vdk-red-title         { font-size: 24px; margin-bottom: 10px; }
    .vdk-subtitle          { font-size: 18px; margin-bottom: 14px; }
    .vdk-bullet-list li    { font-size: 14px; }
    .vdk-slider-img-wrap   { height: 280px; }

    .vdk-tabs-section      { padding: 40px 0 40px 0; }
    .vdk-tabs-bar          { margin-bottom: 30px; }
    .vdk-tab-active        { font-size: 14px; padding: 16px 12px; }
    .vdk-tab-inactive      { font-size: 14px; padding: 16px 12px; }
    .vdk-download-label    { font-size: 18px; padding: 0 20px; }
    .vdk-pdf-icon          { width: 32px; height: 32px; }
    .vdk-download-icon     { padding: 14px 30px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .vdk-hero              { height: 400px; }
    .vdk-hero-bg           { display: none; }
    .vdk-hero-bg-mobile    { display: block; }
    .vdk-hero-content      { padding: 0 16px; }
    .vdk-hero-title        { font-size: 24px; }
    .vdk-hero-divider      { width: 100%; margin-bottom: 15px; }
    .vdk-hero-desc         { font-size: 14px; }

    .vdk-breadcrumb        { padding: 22px 0 0 0; }
    .vdk-breadcrumb-inner  { padding: 0 16px; gap: 16px; }
    .vdk-bc-item           { font-size: 14px; }
    .vdk-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .vdk-inner             { padding: 0 16px; }
    .vdk-tab-icon          { width: 19px; height: 19px; }

    .vdk-section-content   { padding: 30px 0 30px 0; }
    .vdk-content-grid      { gap: 30px; }
    .vdk-red-title         { font-size: 20px; margin-bottom: 10px; }
    .vdk-subtitle          { font-size: 16px; margin-bottom: 14px; }
    .vdk-bullet-list li    { font-size: 14px; }
    .vdk-slider-img-wrap   { height: 259px; }
    .vdk-dot               { width: 5px; height: 5px; }

    .vdk-tabs-section      { padding: 30px 0 60px 0; }
    .vdk-tabs-bar          { flex-direction: column;gap:1px; }
    .vdk-tab-active        { flex: none; font-size: 16px; padding: 20px 8px; width: 100%; }
    .vdk-tab-active::after { display: none; }
    .vdk-tab-inactive      { flex: none; font-size: 16px; padding: 20px 8px; width: 100%; }
    .vdk-download-label    { font-size: 14px; }
    .vdk-download-list {  width:100%;}
    .vdk-pdf-icon          { width: 24px; height: 24px; }
    .vdk-download-icon     { padding: 14px 20px; }
  }
`;

/* ── Tab Icons ── */
const DatasheetIcon   = () => <img src={DatasheetTabIcon}   alt="" className="vdk-tab-icon" />;
const InstructionIcon = () => <img src={InstructionTabIcon} alt="" className="vdk-tab-icon" />;
const WhitepaperIcon  = () => <img src={WhitepaperTabIcon}  alt="" className="vdk-tab-icon" />;
const PdfIcon         = () => <img src={PdfSvgIcon}         alt="PDF" className="vdk-pdf-icon" />;

const TAB_ICONS = {
  datasheet:   <DatasheetIcon />,
  instruction: <InstructionIcon />,
  whitepaper:  <WhitepaperIcon />,
};

export default function Vedika7kHz() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeTab,   setActiveTab]   = useState("datasheet");
  const intervalRef  = useRef(null);
  const dragStartX   = useRef(null);

  /* ── Autoplay ── */
  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  const startAutoplay = () => {
    stopAutoplay(); // always clear before starting — prevents interval stacking
    intervalRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_SPEED);
  };
  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  /* ── Dot click ── */
  const goToSlide = (i) => {
    stopAutoplay();
    setActiveSlide(i);
    startAutoplay();
  };

  /* ── Drag / swipe ── */
  const onDragStart = (e) => {
    dragStartX.current = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    stopAutoplay();
  };
  const onDragEnd = (e) => {
    if (dragStartX.current === null) return;
    const endX = e.type === "touchend" ? e.changedTouches[0].clientX : e.clientX;
    const diff  = dragStartX.current - endX;
    if (Math.abs(diff) > 80) {
      setActiveSlide(prev =>
        diff > 0
          ? (prev + 1) % SLIDES.length
          : (prev - 1 + SLIDES.length) % SLIDES.length
      );
    }
    dragStartX.current = null;
    startAutoplay();
  };

  const currentTab = TABS.find(t => t.key === activeTab);

  return (
    <div className="vdk-wrap">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="vdk-hero">
        <img className="vdk-hero-bg"        src={HeroBgImg}       alt="" />
        <img className="vdk-hero-bg-mobile" src={HeroBgImgMobile} alt="" />
        <div className="vdk-hero-overlay" />
        <div className="vdk-hero-content">
          <h1 className="vdk-hero-title">Vedika 7.0kHz</h1>
          <hr className="vdk-hero-divider" />
          <p className="vdk-hero-desc">
            Ador has a robust solution which is not a project and doesn't need any mechanical or process shut down for enhancing performance of ESP.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="vdk-breadcrumb" aria-label="Breadcrumb">
        <div className="vdk-breadcrumb-inner">
          <a href="/" className="vdk-bc-item">Home</a>
          <span className="vdk-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="vdk-bc-item">Products</a>
          <span className="vdk-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products/hfps" className="vdk-bc-item">HFPS</a>
          <span className="vdk-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="vdk-bc-item vdk-active">Vedika 7.0kHz</span>
        </div>
      </nav>

      {/* ══ 3. CONTENT ══ */}
      <section className="vdk-section-content">
        <div className="vdk-inner">
          <div className="vdk-content-grid">

            {/* Left */}
            <div className="vdk-content-left">
              <h2 className="vdk-red-title">Vedika 7.0kHz</h2>
              <h3 className="vdk-subtitle">High Frequency Power Supply</h3>
              <ul className="vdk-bullet-list">
                {BULLETS.map((text, i) => (
                  <li key={i}>{text}</li>
                ))}
              </ul>
            </div>

            {/* Right — slider */}
            <div className="vdk-slider">
              <div
                className="vdk-slider-img-wrap"
                onMouseDown={onDragStart}
                onMouseUp={onDragEnd}
                onMouseLeave={() => { dragStartX.current = null; startAutoplay(); }}
                onTouchStart={onDragStart}
                onTouchEnd={onDragEnd}
              >
                <div
                  className="vdk-slider-track"
                  style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                >
                  {SLIDES.map((src, i) => (
                    <img
                      key={i}
                      className="vdk-slider-img"
                      src={src}
                      alt={`Slide ${i + 1}`}
                      draggable={false}
                    />
                  ))}
                </div>
              </div>
              <div className="vdk-slider-dots">
                {SLIDES.map((_, i) => (
                  <button
                    key={i}
                    className={`vdk-dot${activeSlide === i ? " vdk-dot-active" : ""}`}
                    onClick={() => goToSlide(i)}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══ 4. DOWNLOAD TABS SECTION ══ */}
      <section className="vdk-tabs-section">
        <div className="vdk-inner">

          {/* Tab bar — 3 tabs */}
          <div className="vdk-tabs-bar">
            {TABS.map(tab => (
              <button
                key={tab.key}
                className={activeTab === tab.key ? "vdk-tab-active" : "vdk-tab-inactive"}
                onClick={() => setActiveTab(tab.key)}
              >
                {TAB_ICONS[tab.key]} {tab.label}
              </button>
            ))}
          </div>

          {/* Download rows for active tab */}
          {currentTab && (
            <div className="vdk-download-list">
              {currentTab.downloads.map((item, i) => (
                <a key={i} href={item.href} className="vdk-download-row" target="_blank"
        rel="noopener noreferrer">
                  <span className="vdk-download-label">{item.label}</span>
                  <span className="vdk-download-icon"><PdfIcon /></span>
                </a>
              ))}
            </div>
          )}

        </div>
      </section>

    </div>
  );
}